<template>
	<div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">搜索条件</div>
			<Input placeholder="搜索账户名称" v-model="name" style="width: 150px">
			</Input>
			<Select v-model="cidType" style="width:150px;" clearable placeholder="类型">
				<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">{{ item.type }}</Option>
			</Select>
			<Select v-model="account" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple clearable
				placeholder="请选择账户">
				<Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
					{{ item.account_name}}
				</Option>
			</Select>
			<Select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple
				clearable placeholder="请选择运营">
				<Option v-for="item in operationList" :value="item.uid" :key="item.uid">
					{{ item.username}}
				</Option>
			</Select>
				<Button style="margin-left: 10px;"  type="primary" @click="mySearch">搜索</Button>
				<Button style="margin-left: 10px;" @click="initSearch">重置</Button>
		</div>
		<Table border :columns="columns" :data="sucaiData" @on-sort-change="handleSortChange">
			<template slot-scope="{row, index}" slot="filename">
				<a href="#" @click="showVideo(row.url)">{{row.filename}}</a>
			</template>
			<template slot-scope="{row, index}" slot="have_cost_count">
				<span style="color:#63B3E6;cursor: pointer;" @click.stop="sucaiIdDataClick(row.material_id)">{{row.have_cost_count}}</span>
			</template>
			<template slot-scope="{row, index}" slot="customer_effective">
				<span>{{row.customer_effective}}/<span style="color:#63B3E6;cursor: pointer;" >{{row.customer_effective_rate}}</span></span>
			</template>
			<template slot-scope="{row, index}" slot="msg">
				<div class="image-wrapper" @click="showImage(row.poster_url)">
					<img :src="row.poster_url" alt="image">
				</div>
			</template>
		</Table>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
		<Modal title="阅览图片" v-model="showModal" footer-hide width="650px">
			<img :src="modalImage" v-if="showModal" style="width: 100%">
		</Modal>
		<Modal title="阅览视频" v-model="videoModal" footer-hide>
			<video :src="modalVideo" v-if="videoModal" style="width: 100%;" controls></video>
		</Modal>
		<Modal v-model="sucaiDataModal" width="1200" title="">
			<sucaiIdData :sucaiID="sucaiID" :timePeriod="timePeriod" :timePeriodDate="timePeriodDate" ></sucaiIdData> 
		</Modal>
	</div>
</template>

<script>
	import {
		getAllMediumCode,
		getAllTypeStatic,
		getAdvTypeGroupByCityStaticList,
		getCidTypeList,
		getAdvCityList,
		getToutiaoSrc,
		getAllAccountList,
		getAllOperationList,
		getSucaiDataList
	} from "../../api/advManage";
	import sucaiIdData from "./components/sucaiDataListById.vue"
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "toutiao_adv_data",
		components: {
			sucaiIdData
		},
		data() {
			return {
				columns: [
					{
						title: "素材名称",
						key: "ad_platform_material_name",
						align: 'center'
					},
					{
						title: "素材id",
						key: "material_id",
						align: 'center'
					},
					{
						title: "消耗",
						key: "cost",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "转化",
						key: "account_convert",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "平均成本",
						key: "average_cost",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "有效获客/占比",
						slot: "customer_effective",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "有效获客成本",
						key: "customer_effective_average_cost",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "展现",
						key: "account_show",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "点击",
						key: "account_click",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "点击率",
						key: "account_click_rate",
						align: 'center',
						sortable: 'custom'
					},
					{
						title: "操作人",
						key: "username",
						align: 'center'
					},
				],
				sort: { // 排序参数
					field: '', // 排序的字段  
					order: '' // 排序的顺序（'ascending' 或 'descending'）  
				},
				showModal: false,
				videoModal: false,
				currentVideo: false,
				modalVideo: '',
				modalImage: '',
				sucaiData: [],
				order_type: 'desc',
				name: '',
				page: 1,
				pageSize: 10,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				timePeriod: '5',
				timePeriodDate: [],
				count: 0,
				cidType: [],
				cidTypeList: [],
				cityList: [],
				accountList: [],
				operationList: [],
				operationUser: [],
				account: [],
				sucaiDataModal:false,
				sucaiID:'',
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list
				res = await getAdvCityList(that, data);
				that.cityList = res.data.list
				res = await getToutiaoSrc(that, data);
				that.srcList = res.data.list;
				res = await getAllAccountList(that, data);
				that.accountList = res.data.list;
				res = await getAllOperationList(that, data);
				that.operationList = res.data.list;
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
			},
			initSearch() {
				this.name = '';
				this.page = 1;
				this.pageSize = 10;
				this.city = [];
				this.timePeriod = '5';
				this.timePeriodDate = [];
				this.getList();
			},
			mySearch() {
				this.getList();
			},
			showVideo(video) {
				console.log(video)
				this.modalVideo = video
				this.videoModal = true;
			},
			showImage(image) {
				console.log(image)
				this.showModal = true
				this.modalImage = image
			},
			hideImage() {
				this.showModal = false
				this.modalImage = ''
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			handleSortChange({
				column,
				prop,
				order
			}) {
				this.sort.field = column.key ? column.key : column.slot;
				this.sort.order = order;
				this.page = 1;
				this.getList();
			},
			sucaiIdDataClick(sucaiID) {
				let that = this;
				if(sucaiID =="合计"){
					that.sucaiID = "";
				}else{
					that.sucaiID = sucaiID;
				}
				that.sucaiDataModal = true;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				let res = await getSucaiDataList(that, data);
				that.sucaiData = res.data.list;
				that.count = res.count;
			},
		},
	};
</script>

<style lang="less" scoped>
	#myChart {
		width: 100%;
		height: 700px;
		background-color: #FFFFFF;
		padding-top: 30px;
	}

	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	.image-wrapper {
		width: 100px;
		height: 100px;
		overflow: hidden;
		position: relative;
	}

	.image-wrapper img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.image-modal {
		display: none;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		overflow: auto;
		background-color: rgba(0, 0, 0, 0.9);
	}

	.image-modal-content {
		margin: auto;
		display: block;
		width: 80%;
		max-width: 700px;
		position: relative;
		padding: 20px;
	}

	.close {
		color: #fff;
		position: absolute;
		top: 10px;
		right: 25px;
		font-size: 35px;
		font-weight: bold;
		cursor: pointer;
	}

	.close:hover,
	.close:focus {
		color: #bbb;
		text-decoration: none;
		cursor: pointer;
	}

	a {
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}
</style>